var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRemoveFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#A7ADC3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6196 5.26445C13.02 4.89595 13.6325 4.916 14.0154 5.30315L14.5907 5.8848C14.9736 6.2719 14.9934 6.8912 14.6289 7.29605C14.0863 7.89875 13.2282 8.83575 12.1639 9.9431C13.2788 11.1 14.1773 12.0807 14.7384 12.7039C15.1029 13.1088 15.0831 13.7281 14.7002 14.1152L14.1249 14.6968C13.742 15.084 13.1295 15.104 12.7291 14.7355C12.1129 14.1684 11.1435 13.2606 10 12.134C8.85645 13.2606 7.88705 14.1684 7.2709 14.7355C6.8705 15.104 6.258 15.084 5.8751 14.6968L5.2998 14.1152C4.9169 13.7281 4.8971 13.1088 5.2616 12.7039C5.8227 12.0807 6.72115 11.1 7.83605 9.9431C6.7718 8.83575 5.9137 7.89875 5.37105 7.29605C5.00655 6.8912 5.0264 6.2719 5.4093 5.8848L5.9846 5.30315C6.3675 4.916 6.98 4.89595 7.3804 5.26445C7.9768 5.81335 8.9041 6.6815 10 7.75825C11.0959 6.6815 12.0232 5.81335 12.6196 5.26445Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveFileIcon);
export default __webpack_public_path__ + "static/media/removeFileIcon.8d387dac8eda4ce4b41e99437ca16476.svg";
export { ForwardRef as ReactComponent };